import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { RotatingSquare } from "react-loader-spinner";
import OrderSetAssign from "../../../../Pages/Users/UserDetails/OrderSetAssign/OrderSetAssign";
import UserOrderList from "../../../../Pages/Users/UserOrderList/UserOrderList";

const AgentUserDetails = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState([]);
    const [userUpdateData, setuserUpdateData] = useState({});

    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/user/view/single/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setUserData(data.data);
            });
    }, [userUpdateData]);

    const [data, setData] = useState([]);
    useEffect(() => {
        fetch(`https://api.velormall.com/api/admin/user/view/history/view/${id}`, {
            method: "GET",
        })
            .then((res) => res.json())
            .then((data) => {
                setData(data);
                setLoading(false);
            });
    }, []);

    const refSubmitDis = useRef();
    // Balance Add

    const [BalanceAddModalshow, setBalanceAddModalShow] = useState(false);
    const handleBalanceAddModalClose = () => setBalanceAddModalShow(false);
    const handleBalanceAddModalShow = () => setBalanceAddModalShow(true);

    // view data
    const [BalanceAddDataVulue, setBalanceAddDataVulue] = useState({});

    // store data

    const handleSubmitData = (event) => {
        event.preventDefault();
        const storeData = { ...BalanceAddDataVulue, user_id: id };
        refSubmitDis.current.setAttribute("disabled", true);
        fetch(`https://api.velormall.com/api/admin/user/view/balance/add`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(storeData),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success === false) {
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    refSubmitDis.current.removeAttribute("disabled");
                } else {
                    handleBalanceAddModalClose();
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    event.target.reset();
                    refSubmitDis.current.removeAttribute("disabled");
                }
            })
            .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
    };

    const handleBalanceAddInputBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...BalanceAddDataVulue };
        newData[field] = value;
        setBalanceAddDataVulue(newData);
    };

    // Balance Minus

    const [BalanceMinusModalshow, setBalanceMinusModalShow] = useState(false);
    const handleBalanceMinusModalClose = () => setBalanceMinusModalShow(false);
    const handleBalanceMinusModalShow = () => setBalanceMinusModalShow(true);

    // view data
    const [BalanceMinusDataVulue, setBalanceMinusDataVulue] = useState({});

    // store data

    const handleBalanceMinusSubmitData = (event) => {
        event.preventDefault();
        const storeData = { ...BalanceMinusDataVulue, user_id: id };
        refSubmitDis.current.setAttribute("disabled", true);
        fetch(`https://api.velormall.com/api/admin/user/view/balance/subtract`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(storeData),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success === false) {
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    refSubmitDis.current.removeAttribute("disabled");
                } else {
                    handleBalanceMinusModalClose();
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    event.target.reset();
                    refSubmitDis.current.removeAttribute("disabled");
                }
            })
            .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
    };

    const handleBalanceMinusInputBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...BalanceMinusDataVulue };
        newData[field] = value;
        setBalanceMinusDataVulue(newData);
    };




    // banned user

    const [BannedModalshow, setBannedModalShow] = useState(false);
    const handleBannedModalClose = () => setBannedModalShow(false);
    const handleBannedModalShow = () => setBannedModalShow(true);

    // view data
    const [BanDataVulue, setBanDataVulue] = useState({});

    // store data

    const handleBanSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        fetch(`https://api.velormall.com/api/admin/user/view/banned/${id}`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(BanDataVulue),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success === false) {
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });

                    refSubmitDis.current.removeAttribute("disabled");
                } else {
                    handleBannedModalClose();
                    toast.error(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setuserUpdateData(data?.data);
                    event.target.reset();
                    refSubmitDis.current.removeAttribute("disabled");
                }
            })
            .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
    };

    const handleUnBanSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        fetch(`https://api.velormall.com/api/admin/user/view/banned/${id}`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                toast.success(`${data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setuserUpdateData(data?.data);
                refSubmitDis.current.removeAttribute("disabled");
            })
            .catch((error) => refSubmitDis.current.removeAttribute("disabled"));
    };

    const handleUserBanInputBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...BanDataVulue };
        newData[field] = value;
        setBanDataVulue(newData);
    };

    const UserTradeUserTrade = useRef();

    const handleUserTrade = (event) => {
        event.preventDefault();
        UserTradeUserTrade.current.setAttribute("disabled", true);
        const formData = new FormData(event.currentTarget);
        const InpuData = Object.fromEntries(formData);
        fetch(`https://api.velormall.com/api/admin/user/view/trade/update/${id}`, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(InpuData),
        })
            .then((res) => res.json())
            .then((data) => {
                toast.success(`${data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                UserTradeUserTrade.current.removeAttribute("disabled");
            })
            .catch((error) => {
                // console.log(error)
            });
    };

    if (loading) {
        return (
            <>
                <div className="loader-css">
                    <RotatingSquare
                        visible={true}
                        height="100"
                        width="100"
                        color="#4fa94d"
                        ariaLabel="rotating-square-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                </div>
            </>
        );
    }
    return (
        <>
            <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                <h6 className="page-title">
                    User Detail - {userData?.username}
                </h6>
                <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins"></div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="row gy-4">
                        <div className="col-xxl-3 col-sm-6">
                            <div className="widget-two style--two box--shadow2 b-radius--5 bg--19">
                                <div className="widget-two__icon b-radius--5 bg--primary">
                                    <i className="las la-money-bill-wave-alt"></i>
                                </div>
                                <div className="widget-two__content">
                                    <h3 className="text-white">${userData?.balance}</h3>
                                    <p className="text-white">Balance</p>
                                </div>
                                <Link
                                    to={`/agent/report/transaction/history/${userData?._id}`}
                                    className="widget-two__btn"
                                >
                                    View All
                                </Link>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-sm-6">
                            <div className="widget-two style--two box--shadow2 b-radius--5 bg--primary">
                                <div className="widget-two__icon b-radius--5 bg--primary">
                                    <i className="las la-wallet"></i>
                                </div>
                                <div className="widget-two__content">
                                    <h3 className="text-white">
                                        ${data?.DepositAcceptBalanceSum}
                                    </h3>
                                    <p className="text-white">Deposits</p>
                                </div>
                                <Link
                                    to={`/agent/deposit/history/${userData?._id}`}
                                    className="widget-two__btn"
                                    alt=""
                                >
                                    View All
                                </Link>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-sm-6">
                            <div className="widget-two style--two box--shadow2 b-radius--5 bg--1">
                                <div className="widget-two__icon b-radius--5 bg--primary">
                                    <i className="fas fa-wallet"></i>
                                </div>
                                <div className="widget-two__content">
                                    <h3 className="text-white">
                                        ${data?.WithdrawalAcceptBalanceSum}
                                    </h3>
                                    <p className="text-white">Withdrawals</p>
                                </div>
                                <Link
                                    to={`/agent/withdraw/history/${userData?._id}`}
                                    className="widget-two__btn"
                                    alt=""
                                >
                                    View All
                                </Link>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-sm-6">
                            <div className="widget-two style--two box--shadow2 b-radius--5 bg--17">
                                <div className="widget-two__icon b-radius--5 bg--primary">
                                    <i className="las la-exchange-alt"></i>
                                </div>
                                <div className="widget-two__content">
                                    <h3 className="text-white">{data?.TotalTransactions}</h3>
                                    <p className="text-white">Transactions</p>
                                </div>
                                <Link
                                    to={`/agent/report/transaction/history/${userData?._id}`}
                                    className="widget-two__btn"
                                >
                                    View All
                                </Link>
                            </div>
                        </div>
                    </div>



                    <div className="row">
                        <div className="col-6">
                            <OrderSetAssign />
                        </div>
                    </div>

                </div>
            </div>

            <UserOrderList />

        </>
    );
};

export default AgentUserDetails;
